import React, {Component} from "react";
import LocationTypeahead from '@xo-union/tk-component-location-typeahead';
import { compose } from '@xo-union/react-css-modules';
import style from './FashionLocationTypeStyle.css';

export default class FashionLocationTypeahead extends Component{

  handleChange(selected) {
    Fashion.currentView().trackLocationSelected(selected);
  }

  render() {
    return <LocationTypeahead classes={compose(style)} onChange={this.handleChange} name='Enter Your City'/>;
  }
}
